module.exports = __webpack_public_path__ + "static/media/dubai.df994899.jpg";